import { FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { SignatureCard } from '../../molecules';

const SignCardWithCheckbox = ({
  signature,
  enable,
  onClick,
  title,
  signHere,
  signDate,
}: any) => {

  const handleClick = (e: any) => {
    if (e.target) {
      onClick(e.target.value);
    }
  };

  return (
    <>
      <div>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                id="agreeSignature"
                value="agreed"
                checked={enable}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleClick(e)
                }
              />
            }
            label="Agree and add signature"
          />
        </FormGroup>
      </div>
      {enable && (
        <div className="mt-16">
          <SignatureCard
            hideClear
            hideSignHereText
            populate={true}
            sign={signature}
            signHere={signHere}
            signDate={signDate}
            title={title}
          />
        </div>
      )}
    </>
  );
};

export default SignCardWithCheckbox;
